import { DispensaryCollectionsPage } from 'src/dispensary/collections';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

export default Object.assign(DispensaryCollectionsPage, { layout: CoreMenuLayout });
